<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ invoiceId ? "Edit Invoice" : "New Invoice" }}
  </h2>

  <form [formGroup]="newInvoiceForm">
    <div class="chart-account-form-wrapper">
      <!-- Invoice No -->
      <div class="form-wrapper">
        <label for="">Invoice No <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Invoice No"
            formControlName="invoiceNo"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('invoiceNo')?.touched &&
              newInvoiceForm.get('invoiceNo')?.hasError('required')
            "
          >
            Invoice number is required.
          </mat-error>
        </div>
      </div>

      <!-- Customer ID -->
      <div class="form-wrapper">
        <label for="">Customer <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Customer</mat-label>
          <mat-select formControlName="customerId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No customers found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let customer of customers"
              [value]="customer.id"
            >
              {{ customer.firstName }} {{ customer.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('customerId')?.touched &&
              newInvoiceForm.get('customerId')?.hasError('required')
            "
          >
            Customer is required.
          </mat-error>
        </div>
      </div>

      <!-- Order ID -->
      <div class="form-wrapper">
        <label for="">Order <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Order</mat-label>
          <mat-select formControlName="orderId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No Orders found'"
                (input)="onOrderSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let order of orderData" [value]="order.id">
              {{ order.orderCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('orderId')?.touched &&
              newInvoiceForm.get('orderId')?.hasError('required')
            "
          >
            Order is required.
          </mat-error>
        </div>
      </div>

      <!-- Due Date -->
      <div class="form-wrapper">
        <label for="">Due Date <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Choose a date"
            formControlName="dueDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('dueDate')?.touched &&
              newInvoiceForm.get('dueDate')?.hasError('required')
            "
          >
            Due Date is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="item-service-adding-table-wrapper" formArrayName="items">
      <table>
        <thead>
          <tr>
            <th>Item Name <span class="red">*</span></th>
            <th>Description</th>
            <th>Quantity <span class="red">*</span></th>
            <th>Unit Price<span class="red">*</span></th>
            <th>Sub Total</th>
            <th>VAT(5%)</th>
            <th>Total Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let item of items.controls; let i = index"
            [formGroupName]="i"
          >
            <!-- Item description data -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Item Name"
                      formControlName="itemName"
                    />
                  </mat-form-field>
                  <div
                    class="custom-error"
                    *ngIf="item.get('itemName')?.touched"
                  >
                    <span>
                      <mat-error
                        *ngIf="item.get('itemName')?.errors?.['required']"
                      >
                        Item is required.
                      </mat-error>
                    </span>
                  </div>
                </div>
              </div>
            </td>

            <!-- Description  -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Description"
                      formControlName="description"
                    />
                  </mat-form-field>
                </div>
              </div>
            </td>
            <!-- Quanitity data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Quantity"
                    formControlName="quantity"
                    (keypress)="allowOnlyInteger($event)"
                    (paste)="blockPasteNonInteger($event)"
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('quantity')?.touched &&
                        item.get('quantity')?.hasError('required')
                      "
                      >Quantity is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('quantity')?.hasError('nonNegative')"
                      >Quantity must be greater than 0.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Rate data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Unit price"
                    formControlName="rate"
                    (keypress)="allowOnlyNumberWithDecimal($event)"
                    (paste)="blockPaste($event)"
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('rate')?.touched &&
                        item.get('rate')?.hasError('required')
                      "
                      >Unit price is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('rate')?.hasError('nonNegative')"
                      >Unit price cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Sub Total"
                    formControlName="subTotal"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('subTotal')?.touched &&
                        item.get('subTotal')?.hasError('required')
                      "
                      >Sub Total is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('subTotal')?.hasError('nonNegative')"
                      >Sub Total cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <!-- Vat tax Data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="VAT"
                    formControlName="tax"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('tax')?.touched &&
                        item.get('tax')?.hasError('required')
                      "
                      >VAT is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('tax')?.hasError('nonNegative')"
                      >VAT cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Total amount data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Total Amount"
                    formControlName="totalAmount"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('totalAmount')?.touched &&
                        item.get('totalAmount')?.hasError('required')
                      "
                    >
                      Amount is required.
                    </mat-error>
                  </span>
                </div>
              </div>
              <span class="delete">
                <img
                  src="../../../assets/images/icons/icon-close.svg"
                  alt="Delete"
                  (click)="onRemoveNewlyAddedItems(i)"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" (click)="addItem()">
        <img src="../../../assets/images/icons/icon-add-color.svg" alt="Add" />
        Add
      </button>
    </div>

    <div class="notes-tatal-amount-container">
      <div class="form-container">
        <div class="form-wrapper">
          <label for="">Discount</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter discount amount"
              formControlName="discount"
              (keypress)="allowOnlyNumberWithDecimal($event)"
              (paste)="blockPaste($event)"
            />
          </mat-form-field>

          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="newInvoiceForm.get('discount')?.hasError('nonNegative')"
                >Discount amount cannot be negative.</mat-error
              >
            </span>
            <mat-error
              *ngIf="newInvoiceForm.get('discount')?.hasError('totalNegative')"
            >
              Discount cannot make the total amount negative
            </mat-error>
          </div>
        </div>
      </div>
      <div class="empty-div"></div>

      <div class="amount-table-div">
        <div>
          <h6>
            SubTotal<span>: AED {{ overallSubTotal | number : "1.2-2" }}</span>
          </h6>
          <h6>
            VAT (5%)<span>: AED {{ overallVat | number : "1.2-2" }}</span>
          </h6>
          <h6>
            Discount(-)<span
              >: AED {{ overallDiscount | number : "1.2-2" }}</span
            >
          </h6>
        </div>
        <div>
          <h4>
            Total Amount<span
              >: AED {{ overallTotalAmount | number : "1.2-2" }}</span
            >
          </h4>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <ng-container *ngIf="invoiceData?.invoiceStatus !== 'Pending'">
        <button class="cmn-next-btn" type="button" (click)="onSubmit('Draft')">
          Save as draft
        </button>
      </ng-container>

      <button class="cmn-next-btn" type="button" (click)="onSubmit('Pending')">
        Save
      </button>
    </div>
  </form>
</section>
